<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loadingDriverData"
    >
      <b-row
        v-if="driverData"
      >
        <b-col md="12">
          <sticky-driver-data
            viewd-in="driver-details"
            @refetch-driver-details="$emit('refetch-driver-details')"
          />
        </b-col>
        <b-col md="12">
          <DriverUserHealth />
        </b-col>
        <b-col md="12">
          <ViolationAggs />
        </b-col>
        <b-col md="8">
          <personal-information
            :driver-data="driverData"
            :driver-rating="driverRating"
          />
        </b-col>
        <b-col md="4">
          <car-details :driver-data="driverData" />
        </b-col>
        <!-- <b-col
          md="4"
        >
          <last-completed-trip user-type="driver" />
        </b-col> -->
        <b-col md="12">
          <LocationDetails
            v-if="driverData"
          />
        </b-col>
        <b-col md="12">
          <LastCompletedTrip user-type="driver" />
        </b-col>
        <b-col
          v-if="$can('read', 'driver-devices')"
          md="12"
        >
          <DeviceDetailsV2
            v-if="driverData"
            :driver="driverData"
          />
        </b-col>
        <b-col md="12">
          <documents :driver-data="driverData" />
        </b-col>

      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow, BCol, BOverlay,
} from 'bootstrap-vue'
import StickyDriverData from '../../StickyDriverData.vue'
import PersonalInformation from './PersonalInformation.vue'
import CarDetails from './CarDetails.vue'
// import DeviceDetails from './DeviceDetails.vue'
import Documents from './Documents.vue'
import LastCompletedTrip from '@/views/driver-user-shared/last-completed-trip/LastCompletedTrip.vue'
import DeviceDetailsV2 from './DeviceDetailsV2.vue'
import LocationDetails from './LocationDetails.vue'
import DriverUserHealth from '@/views/driver-user-shared/driver-user-trips/components/DriverUserHealth.vue'
import ViolationAggs from './ViolationAggs.vue'

export default {
  components: {
    StickyDriverData,
    ViolationAggs,
    PersonalInformation,
    CarDetails,
    DriverUserHealth,
    // DeviceDetails,
    Documents,
    BRow,
    BCol,
    BOverlay,
    LastCompletedTrip,
    DeviceDetailsV2,
    LocationDetails,
  },
  props: {
    loadingDriverData: {
      type: Boolean,
      default: false,
    },
    driverData: {
      type: Object,
      default: () => {},
    },
    driverRating: {
      type: [Number, String],
      default: null,
    },
  },
}
</script>

<style>

</style>
